import React from "react";
import { Link } from "react-router";
import { DailyIcon } from "@/features/daily/components/DailyIcon";
import type { DayFilterVm } from "@/features/daily/components/diagnostic/diagnostic-view-model";

type Props = {
    tabs: DayFilterVm[];
    chips: DayFilterVm[];
};

/**
 * D107: the legacy header in the redesign's style — three tabs with icons, the two
 * narrower filters of «Hoy» as chips, and which day the table is showing. Every tab
 * is a real URL with the count the server stated for the whole day. The day itself is
 * the date control's (D131), so no second label repeats it.
 */
export const DayFilters: React.FC<Props> = ({ tabs, chips }) => {
    const chipActive = chips.some((chip) => chip.current);
    return (
        <div className="daily-day-header">
            <nav aria-label="Filtros del día" className="daily-day-tabs">
                <ul className="daily-filters">
                    {tabs.map((tab) => (
                        <li key={tab.filter}>
                            <Link
                                className="daily-day-tab"
                                to={tab.href}
                                title={tab.description}
                                aria-describedby={`daily-day-tab-${tab.filter}`}
                                aria-current={tab.current || (tab.filter === "all" && chipActive) ? "page" : undefined}
                            >
                                <DailyIcon name={tab.icon} />
                                {tab.label}
                            </Link>
                            <span id={`daily-day-tab-${tab.filter}`} className="daily-visually-hidden">{tab.description}</span>
                        </li>
                    ))}
                </ul>
                <ul className="daily-filters" aria-label="Dentro de Hoy">
                    {chips.map((chip) => (
                        <li key={chip.filter}>
                            <Link className="daily-button" to={chip.href} aria-current={chip.current ? "page" : undefined}>
                                {chip.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};
